<template>
  <div title="Nancy" class="e-icon-settings dlg-template">{{ this.Header }} Document</div>
</template>

<script>
import Vue from "vue";

export default {
  name: "FormsCategoryDocumentModalHeader",
  components: {},
  data() {
    return {
      Header: "Add",
    };
  },
  methods: {
    setContent(key) {
      this.Header = key;
    },
  },
};
</script>
